<template>
  <div class="wrapper-acquisition">
    <div class="gate">
      <div class="gate-logo">
        <img src="/img/akusisiuser/logomasjid.svg" />
      </div>
      <div class="gate-title">
        Pilih jenis akun yang ingin Anda Daftarkan
      </div>

      <a
        href="javascript:void(0)"
        class="gate-choose"
        @click="goToPage('akusisi-user-dkm')"
      >
        <div class="image">
          <!-- <img class="icon-role" src="/img/icons/icon_dkm.svg" /> -->
          <img src="/img/akusisiuser/masjid.svg" />
        </div>
        <div class="content">
          <h5>Sebagai DKM</h5>
          <p>
            Memberikan kenyamanan & <br />
            keamanan dalam Laporan <br />
            keuangan masjed.
          </p>
        </div>
        <div class="navigation">
          <img class="icon_arrow" src="/img/icons/icon_arrow.svg" />
        </div>
      </a>

      <a
        href="javascript:void(0)"
        class="gate-choose"
        @click="goToPage('akusisi-user-ustad')"
      >
        <div class="image">
          <!-- <img class="icon-role" src="/img/icons/icon_ustad.svg" /> -->
          <img src="/img/akusisiuser/ustad.svg" />
        </div>
        <div class="content">
          <h5>Sebagai Ustad</h5>
          <p>Memudahkan dakwah secara <br />online.</p>
        </div>
        <div class="navigation">
          <img class="icon_arrow" src="/img/icons/icon_arrow.svg" />
        </div>
      </a>

      <a
        href="javascript:void(0)"
        class="gate-choose"
        @click="goToPage('akusisi-user-relawan')"
      >
        <div class="image">
          <!-- <img class="icon-role" src="/img/icons/icon_relawan.svg" /> -->
          <img src="/img/akusisiuser/relawan.svg" />
        </div>
        <div class="content">
          <h5>Sebagai Relawan</h5>
          <p>Mendukung pemberdayaan <br />Masjid dan Ekonomi Umat.</p>
        </div>
        <div class="navigation">
          <img class="icon_arrow" src="/img/icons/icon_arrow.svg" />
        </div>
      </a>

      <a
        href="javascript:void(0)"
        class="gate-choose"
        @click="goToPage('akusisi-user-yatimdhuafa')"
      >
        <div class="image">
          <!-- <img
            class="icon-role"
            src="/img/icons/icon_yatimdhuafa.svg"
          /> -->
          <img src="/img/akusisiuser/jamaah.svg" />
        </div>
        <div class="content">
          <h5>Sebagai Dhuafa / Yatim</h5>
          <p>
            Lebih mudah mendapatkan <br />berkah dimanapun, kapanpun.
          </p>
        </div>
        <div class="navigation">
          <img class="icon_arrow" src="/img/icons/icon_arrow.svg" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reff_code: '',
    };
  },
  mounted() {
    this.reff_code = this.$route.params.ref_code;
  },
  methods: {
    // akusisi-user-dkm
    goToPage(name) {
      this.$router.push({
        name: name,
        params: { ref_code: this.reff_code },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./scss/akusisi.scss');
</style>
